import Header from '@editorjs/header'; 
import Paragraph  from "@editorjs/paragraph";
import List from '@editorjs/list';
import Checklist from '@editorjs/checklist';
//import ImageTool from '@editorjs/image';
import LinkTool from '@editorjs/link';
import Table from '@editorjs/table';
import CodeTool from '@editorjs/code';
import SimpleImage from '@editorjs/simple-image';
import Delimiter from '@editorjs/delimiter'
import InlineCode from '@editorjs/inline-code'
import RawTool from '@editorjs/raw';

export const EDITOR_JS_TOOLS = {
  // NOTE: Paragraph is default tool. Declare only when you want to change paragraph option.
  // paragraph: Paragraph,
  table: Table,
  list: List,
  code: CodeTool,
  linkTool: LinkTool,
  header: Header,
  checklist: Checklist,
  delimiter: Delimiter,
  inlineCode: InlineCode,
  simpleImage: SimpleImage,
  raw: RawTool
}
